<template src="./promozioni.html"></template>

<script>
import calendar from "@/components/ui/Calendar";
import { get_promozioni } from "@/api/api.statistiche.js";
import mixinsStatistiche from "./mixinsStatistiche.js"

export default {
  mixins: [mixinsStatistiche],
  components: { calendar },
  props: {
    caricaDatiPromozioni: { type: Boolean, default: false },
    confermati: { type: Number, default: 2 },
  },

  data: () => ({
    attesa: false,
    headersDatiEsposizioni: [],
    elencoPromo: [],
    dialogSceltaPromo: false,
    promoMulti: [],
    search: "",
    valore: "",
    dataDa: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
    dataA: new Date().getFullYear().toString() + "-" + "12" + "-" + "31",
    promoAttive: true,

    ordDesc: false,
    totalePromozioni: {},

    page: 1,
    pageCount: 0,
    itemsPerPage: 999,


    dialogDataInizio1: false,
    dialogDataFine1: false,
    dataSelIT1: new Date().toISOString().substr(0, 10),
    dataSelIT2: new Date().toISOString().substr(0, 10),

    sortBy: 'RagSoc',
    sortDesc: false,
  }),

  methods: {
    async caricaDati() {
      this.attesa = true;
      if (!this.verificaPeriodi()) return;

      let par = "";
      if (this.userSwitch.Codice != undefined)
        par = "?idAgente=" + this.userSwitch.Codice;
      else if (this.$store.getters["user/getCodice"])
        par = "?idAgente=" + this.$store.getters["user/getCodice"];
      else if (this.role == "Admin") par = "?idAgente=0";

      par += "&confermati=";
      if (this.confermati == 0) par += "1";
      // confermati
      else if (this.confermati == 1) par += "3";
      // consegnati
      else par += "0";
      par += "&promoAttive=" + (this.promoAttive ? 1 : 0).toString();
      let data = {
        dataDa1: this.dataDa,
        dataA1: this.dataA,
      };

      let res = await get_promozioni(par, data);

      this.elencoPromo = res.data;
      this.attesa = false;

      let totale = this.totalePromozioni;
      this.elencoPromo.filter(function (dett) {
        if (!dett.RagSoc.includes("zzzzz")) return dett;
        else totale = dett;
      });
      this.totalePromozioni = totale;

      this.aggiornaHeadersEsp();
    },

    aggiornaHeadersEsp() {
      this.headersDatiEsposizioni = [
        { text: "Cliente", value: "RagSoc", sortable: true },
        {
          text: "Laminato",
          value: "Laminato",
          class: "pl-2 pr-2",
          sortable: false,
        },
        {
          text: "Laccato",
          value: "Laccato",
          class: "pl-2 pr-2",
          sortable: false,
        },
        {
          text: "Porte vendute in promo",
          value: "Quantita",
          class: "pl-0 pr-0",
          sortable: true,
        },
        {
          text: "Fatturato",
          value: "Fatturato",
          sortable: true,
        },
        {
          text: "Fatturato in promo",
          value: "FatturatoPromo",
          class: "pl-0 pr-0",
          sortable: true,
        },
        {
          text: "Differenza fatturato",
          value: "FatturatoDiff",
          class: "pl-0 pr-0",
          sortable: true,
        },
        { text: "PDF", value: "", class: "pl-2 pr-2", sortable: false },
      ];
    },

    /* ordinaTabellaEsp(item) {
      if (item == null || item == undefined) return;
      if (!item.sortable) return;

      if (this.valore == item.value) this.ordDesc = !this.ordDesc; //se clicco un'altra volta sulla colonna inverte l'ordinamento
      this.valore = item.value;
    }, */

    ordinaTabellaEsp(column) {
      // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
        this.sortBy = column;
        this.sortDesc = false;
      }
    },

    getDatiEsposizioni() {
      if (
        this.elencoPromo == null ||
        this.elencoPromo == undefined ||
        this.elencoPromo.length <= 0
      )
        return;
      let elenco = [];
      this.elencoPromo.forEach((el) => {
        elenco.push(el);
      });

      switch (this.valore) {
        case "CLRAGSOC":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() < b.RagSoc.toLowerCase() ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() > b.RagSoc.toLowerCase() ? 1 : -1
            );
          break;
        case "PorteVendute":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.PorteVendute < b.PorteVendute ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.PorteVendute > b.PorteVendute ? 1 : -1
            );
          break;
        case "PorteInExpo":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.PorteInExpo < b.PorteInExpo ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.PorteInExpo > b.PorteInExpo ? 1 : -1
            );
          break;
        case "Fatturato":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.Fatturato) < parseFloat(b.Fatturato) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.Fatturato) > parseFloat(b.Fatturato) ? 1 : -1
            );
          break;
        case "RagSoc":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() < b.RagSoc.toLowerCase() ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() > b.RagSoc.toLowerCase() ? 1 : -1
            );
          break;
        case "Quantita":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.Quantita < b.Quantita ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.Quantita > b.Quantita ? 1 : -1
            );
          break;

        case "FatturatoPromo":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoPromo) < parseFloat(b.FatturatoPromo) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoPromo) > parseFloat(b.FatturatoPromo) ? 1 : -1
            );
          break;

        case "FatturatoDiff":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoDiff) < parseFloat(b.FatturatoDiff) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoDiff) > parseFloat(b.FatturatoDiff) ? 1 : -1
            );
          break;
        default:
          break;
      }

      return elenco;
    },

    apriPdf(file) {
      //apro il file pdf della promo
      window.open(file, "_blank");
    },

    apriDialogSceltaFile(file) {
      if (file.length == 1) this.apriPdf(file[0].Percorso);
      else {
        this.promoMulti = file;
        this.dialogSceltaPromo = true;
      }
    },

    cambioData() {
      this.caricaDati();
    },

    verificaPeriodi() {
      this.setDate();//setto le text-field delle date
      if (this.dataDa >= this.dataA) return false;
      if (this.dataDa2 >= this.dataA2) return false;
      if (this.dataA == this.dataA2 && this.dataDa == this.dataDa2)
        return false;
      return true;
    },

    setDate() {
      let datada = new Date(this.dataDa);
      datada.setDate(datada.getDate()); //formato system
      datada = this.$i2kFunctions.formatDate_IT(datada); //dd/MM//YYYY;
      this.dataSelIT1 = datada;

      let dataa = new Date(this.dataA);
      dataa.setDate(dataa.getDate()); //formato system
      dataa = this.$i2kFunctions.formatDate_IT(dataa); //dd/MM//YYYY;
      this.dataSelIT2 = dataa;
    },
  },

  mounted() {
    if (this.caricaDatiPromozioni) {
      this.caricaDati();
      this.$emit("promozioniCaricate");
    }
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    caricaDatiPromozioni() {
      if (this.caricaDatiPromozioni) {
        this.caricaDati();
        this.$emit("promozioniCaricate");
      }
    },
  },
};
</script>

<style scoped>
.cellaHeader {
  border: 1px solid #dddddd;
  padding: 0;
  margin: 0;
}

#headerRiepilogo {
  min-width: 16%;
  max-width: 16%;
  width: 16% !important;
}

.cellaBody {
  padding: 0.2em !important;
  margin: 0;
}

.cellaEsposizioni {
  justify-content: center;
  text-align: center;
  top: 0;
  padding: 0 !important;
  margin: 0;
}

table th {
  border: 1px solid #cbcbcb;
  font-size: 1.1em !important;
  font-weight: bold !important;
}

table td {
  border: 1px solid #cbcbcb;
  font-size: 101% !important;
}
</style>